import { FC } from 'react';
import { connect } from 'react-redux';

import classNames from 'classnames';
import { useAppSelector } from 'hooks';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { activeFormatSelector } from 'selectors/drawers';

import { IChildInfo } from '../../../api/types';
import { IRootState } from '../../../reducers';
import PdfTitlePageHorizontal from './PdfTitlePageHorizontal';
import PdfTitlePageVertical from './PdfTitlePageVertical';

import './index.scss';

interface IPdfPortfolioTitlePageProps {
  currentStudent?: IChildInfo;
  isStudentInfoShown: boolean;
}

const getAcademicYearsTitle = (academicYears: string[]) => {
  if (academicYears.length === 0) {
    return '';
  }

  const sortedYears = [...academicYears].sort((a, b) => a.localeCompare(b));

  if (academicYears.length === 1) {
    return `За ${academicYears[0]} учебный год`;
  }

  const isSequential = sortedYears.every((year, index) => {
    if (index === 0) {
      return true;
    }

    const prevEndYear = Number(sortedYears[index - 1].split('-')[1]);
    const currentStartYear = Number(year.split('-')[0]);

    return currentStartYear === prevEndYear;
  });

  if (isSequential) {
    return `За ${sortedYears[0].split('-')[0]}-${sortedYears[sortedYears.length - 1].split('-')[1]} учебные годы`;
  }

  return `За ${sortedYears.join(', ')} учебные годы`;
};

const PdfPortfolioTitlePage: FC<IPdfPortfolioTitlePageProps> = ({ currentStudent, isStudentInfoShown }) => {
  const format = useAppSelector(activeFormatSelector);
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const firstname = currentStudent?.firstname;
  const lastname = currentStudent?.lastname;

  const requiredFullName = firstname && lastname ? `${lastname} ${firstname}` : null;
  const fullName = isStudentInfoShown ? requiredFullName : 'Личные данные скрыты';

  return (
    <div
      className={classNames('pdf-portfolio-title-page', {
        'pdf-portfolio-title-page--horizontal': format === 'horizontal',
      })}
    >
      {/** Титульник вставляется в компоненте, из-за того, что периодически он не подгружался, как ресурс */}
      {format === 'horizontal' ? <PdfTitlePageHorizontal /> : <PdfTitlePageVertical />}
      <div
        className={classNames('academic-year', {
          'academic-year--horizontal': format === 'horizontal',
        })}
      >
        {getAcademicYearsTitle(academicYears)}
      </div>
      {fullName && (
        <div
          className={classNames('student-info', {
            'student-info--horizontal': format === 'horizontal',
          })}
        >
          <div className="student-info__fio">{fullName}</div>
          {isStudentInfoShown && <div className="student-info__school">{currentStudent?.schoolName}</div>}
        </div>
      )}
    </div>
  );
};

export default connect((state: IRootState) => ({
  currentStudent: state.currentStudent,
}))(PdfPortfolioTitlePage);
